// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/andong-katuri/Katuri.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/quest/photo_bg_1280x800.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/quest/photo_bg_1920x1200.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/quest/funny_photo_frame.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/quest/funny_photo_prairie_dog.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/quest/shoot_bubble_count.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/quest/shoot_count_digits.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 웃긴 표정 러너 스타일 — 가로 태블릿. 전면 카메라 + 카운트다운/캡처 연출.
 * 모든 클래스는 .fp-runner 하위로 스코프(다른 화면과 충돌 방지).
 */

.fp-runner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 8px;
  /* 가이드 문구 + 카메라 뷰를 살짝 위로 (세로 중앙정렬 기준 상향) */
  margin-top: -80px;
}

.fp-runner .fp-btn {
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 800;
}

/* ── 카메라 오류 ── */
.fp-runner-error {
  text-align: center;
  gap: 16px;
}

.fp-runner .fp-error-icon {
  font-size: 56px;
}

.fp-runner .fp-error-text {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;
  color: #b91c1c;
}

.fp-runner .fp-btn-cancel {
  background: #059669;
  color: #fff;
  padding: 12px 28px;
  font-size: 18px;
  border-radius: 12px;
}

@keyframes fp-pop {
  0% {
    transform: scale(0.85);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* ══ 촬영 화면(카운트다운) — Figma 3272:46598 ══ (2026-08-07 교체, 옛 출처 2300:106265)
   원본 프레임 1920x1200.

   레이어 순서: 카메라(z:1, 화면 전체) → 나무 액자(z:2, **가운데 투명**) →
                프레리독(z:3) → 카운트다운 말풍선(z:4).

   🔴 좌표 규칙이 바뀌었다. 옛 화면은 불투명 배경을 \`100% 100%\` 로 늘려 채우고 그 안의 빈
      사각형에 카메라를 앉혔기 때문에, 오버레이도 같은 비율로 늘어나도록 **% 좌표**를 써야
      했다. 새 액자는 가운데가 투명해 카메라를 통째로 깔고 덮는 구조라, 액자를 뺀 나머지
      요소(말풍선·프레리독)는 그림에 박힌 구멍이 아니라 **화면 위 독립 배치**다.
      → 디자인 수치를 그대로 쓰는 \`--shoot-u\`(Figma 1px) 기준으로 통일한다.
      단 액자 자체는 여전히 \`100% 100%\` 로 늘려 채운다(3:2 태블릿에서 잘림 방지). */

/* 이 컴포넌트만 단독으로 쓰여도 글꼴이 깨지지 않도록 자체 선언
   (OxQuizRunner.css·QuestTagPage.css 도 같은 파일을 선언 — src 가 같아 브라우저가 dedupe) */
@font-face {
  font-family: 'Katuri';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

.fp-shoot {
  --shoot-scale: 1; /* 글자 크기 조절 손잡이. 1 = Figma 원본 */
  --shoot-u: calc(100vw / 1920 * var(--shoot-scale)); /* Figma 1px */

  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* 🔴 촬영 중에는 배경 그림이 없다 (2026-08-07, Figma 3272:46598).
     액자가 **가운데 투명 이미지**라 카메라 위에 덮는 오버레이(.fp-shoot-frame)로 올라간다.
     카메라가 붙기 전 잠깐 흰 화면이 보이지 않게 어두운 초록만 깔아 둔다.
     캡처 후에는 아래 .fp-shoot-done 이 파스텔 배경으로 바꾼다. */
  background-color: #0b2e22;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* 캡처 후 미리보기("이렇게 찍혔어요") — Figma 2300:106134 (파스텔 정원 배경) */
.fp-shoot-done {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (min-width: 1600px) {
  .fp-shoot-done {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}

/* ── 카메라 뷰: 액자 구멍에 맞춘다 ──
   🔴 \`inset: 0\`(화면 전체)로 두면 안 된다 (2026-08-07 수정, 사용자 보고 "테두리 바깥
      흰색에서도 나타난다"). 액자는 가운데만 투명한 게 아니라 **바깥쪽에도 투명 여백**이 있다
      (에셋 알파 실측: 상 57 / 하 32 / 좌 64 / 우 53px). 구멍 밖 투명 영역이 화면의 10.92%
      라서, 전체에 깔린 영상이 나무 테두리 바깥으로 그대로 샜다.

   좌표는 **컨테이너 대비 %** 다. 액자를 \`100% 100%\` 로 늘려 채우므로(태블릿 3:2, 원본 16:10)
   창도 같은 비율로 늘어나야 구멍과 어긋나지 않는다. vw 기준(--shoot-u)으로 두면 종횡비가
   바뀔 때 창이 구멍에서 밀린다.

   구멍(에셋 알파 실측, 1920x1200 기준): x 179..1751 / y 145..1088
   여기에 **바깥으로 6px 여유**를 준다 — 넘친 부분은 나무 테두리(두께 100px 이상)에 가려
   보이지 않는 반면, 모자라면 유기적인 구멍 가장자리에 배경색 틈이 비친다. */
.fp-shoot .fp-shoot-stage {
  position: absolute;
  /* 🔴 액자 구멍 실측 x71..1851 / y71..1134 (2026-08-19 \`fp_ready_bg.webp\` 재사용).
     사방 6 씩 물려 가장자리에 배경색 틈이 생기지 않게 한다(기존 기법 유지). */
  left: 3.3854%;   /* (71-6)/1920 */
  top: 5.4167%;    /* (71-6)/1200 */
  width: 93.3854%;  /* (1781+12)/1920 */
  height: 89.75%;   /* (1065+12)/1200 */
  overflow: hidden;
  background: #0b2e22; /* 카메라 준비 전 흰 화면 대신 어두운 초록 */
  z-index: 1;
}

.fp-shoot .fp-shoot-video,
.fp-shoot .fp-shoot-canvas {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1); /* 셀카 거울 모드 — 사용자가 보는 대로 */
}

.fp-shoot .fp-shoot-canvas {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
}

/* 🔴 스트림 재생 전에는 카메라 영상을 가린다 (2026-08-19 사용자 보고).
   \`getUserMedia\` 가 비동기라 렌더 직후~\`srcObject\` 부착 사이에 **빈 \`<video>\`** 가 남고,
   Android WebView 가 그 구간에 네이티브 재생 오버레이를 그렸다.
   전역 의사요소 억제(\`index.css\`)와 **짝**이다 — 기기에 따라 아이콘이 아니라 빈 판이
   먼저 뜨기도 해서 두 겹으로 막는다.
   ⚠️ \`onPlaying\` 까지만 가린다 — 카메라가 켜지는 순간 아이는 자기 얼굴을 그대로 본다.
   ⚠️ 캡처 후에는 \`.fp-shoot-done .fp-shoot-video { visibility: hidden }\` 이 따로 숨긴다.
   회귀 가드: src/videoPlayOverlay.test.js */
.fp-shoot .fp-shoot-video {
  opacity: 0;
  transition: opacity 120ms linear;
}

.fp-shoot .fp-shoot-video-playing {
  opacity: 1;
}

.fp-shoot .fp-shoot-canvas-show {
  opacity: 1;
}

.fp-shoot .fp-shoot-flash {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(5, 150, 105, 0.6);
  animation: fp-pop 0.25s ease-out;
}

/* ── 사용자가 제공한 1920x1200 투명 사진 프레임 ── */
.fp-shoot .fp-shoot-frame {
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / 100% 100%;
  pointer-events: none;
  z-index: 2;
}

@media (min-width: 1600px) {
}

/* ── 사용자가 제공한 좌하단 프레리독 ── */
.fp-shoot .fp-shoot-photographer {
  position: absolute;
  left: calc(54 * var(--shoot-u));
  bottom: calc(30 * var(--shoot-u));
  width: calc(550 * var(--shoot-u));
  height: calc(630 * var(--shoot-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center bottom / contain;
  pointer-events: none;
  z-index: 3;
}

/* ── 카운트다운 말풍선 (3304:44130) — (1416,30) 460x396 ── */
.fp-shoot .fp-shoot-bubble {
  position: absolute;
  z-index: 4;
}

.fp-shoot .fp-shoot-bubble-right {
  /* 🔴 2026-08-19 — 우상단(1416,30)에서 **우하단**으로 내려왔다 (Figma 3846:45744). */
  left: calc(1399 * var(--shoot-u));
  top: calc(693 * var(--shoot-u));
  width: calc(430 * var(--shoot-u));
  height: calc(441 * var(--shoot-u));
}

.fp-shoot .fp-shoot-bubble-img {
  position: absolute;
  inset: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center / 100% 100%;
}

/* 숫자 (3304:44132) — 중심 x 1646(=960+686), top 96, GosanjaOTF 250px #189018.
   말풍선 상자(left 1416)를 기준으로 하면 중심은 1646-1416 = 230 지점이다. */
.fp-shoot .fp-shoot-count {
  position: absolute;
  /* 🔴 2026-08-19 — 숫자가 **텍스트에서 스프라이트 이미지로** 바뀌었다 (Figma 3846:45746).
     5·4·3·2·1 이 각각 다른 색의 3D 그림이라 폰트로는 재현할 수 없다.
     말풍선(1399,693) 기준 상대좌표 (101,68), 창 228x274.
     🔴 좌표를 transform 으로 잡지 않는다 — 아래 \`fp-count-pop\` 이 transform: scale 을
        애니메이션하므로 translate 가 통째로 무시된다(2026-08-07 실제 사고).
     🔴 글자는 DOM 에 남기고 \`font-size: 0\` 으로 화면에서만 감춘다 — 지우면 \`textContent\` 로
        카운트다운을 확인하는 기존 테스트가 전부 눈이 먼다(접근성 낭독도 유지된다). */
  left: calc(101 * var(--shoot-u));
  top: calc(68 * var(--shoot-u));
  width: calc(228 * var(--shoot-u));
  height: calc(274 * var(--shoot-u));
  font-size: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  /* 🔴 2026-08-19 재작업 — 시트를 **창과 같은 폭의 균일 칸**으로 다시 만들었다.
     사용자 보고: "1은 왼쪽에 2가 살짝 보인다". 원인은 원본 시트의 들쭉날쭉한 자간이었다 —
     창(228=원본 440)을 숫자 중심에 맞추다 보니, 폭이 좁은 '1'(260)에서는 창이 왼쪽으로
     더 뻗어 73 밖에 안 떨어진 '2' 를 약 17 물었다. 자간에 맞춰 오프셋을 손보는 대신
     시트를 440x529 칸 5개(2200x529)로 재구성해 **한 칸 = 한 창**이 되게 했다.
     → 이웃이 들어올 여지가 구조적으로 없고, 오프셋도 창 폭의 정수배로 떨어진다.
     시트 2200x529 → 화면 1140x274.1 (= 228 x5, 274) */
  background-size: calc(1140 * var(--shoot-u)) calc(274.1 * var(--shoot-u));
  animation: fp-count-pop 0.32s ease-out;
}

/* 숫자별 스프라이트 칸 — 시트가 왼쪽부터 5·4·3·2·1 이고 칸 폭이 창과 같으므로
   오프셋은 창 폭(228)의 정수배다. 세로는 칸 안에서 이미 맞춰 두어 0. */
.fp-shoot .fp-shoot-count[data-count="5"] {
  background-position: calc(0 * var(--shoot-u)) calc(0 * var(--shoot-u));
}

.fp-shoot .fp-shoot-count[data-count="4"] {
  background-position: calc(-228 * var(--shoot-u)) calc(0 * var(--shoot-u));
}

.fp-shoot .fp-shoot-count[data-count="3"] {
  background-position: calc(-456 * var(--shoot-u)) calc(0 * var(--shoot-u));
}

.fp-shoot .fp-shoot-count[data-count="2"] {
  background-position: calc(-684 * var(--shoot-u)) calc(0 * var(--shoot-u));
}

.fp-shoot .fp-shoot-count[data-count="1"] {
  background-position: calc(-912 * var(--shoot-u)) calc(0 * var(--shoot-u));
}

@keyframes fp-count-pop {
  0% {
    transform: scale(1.35);
    opacity: 0.35;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* ══ 캡처 후 미리보기 배치 ══
   요구: "사진이 화면 가운데 오도록". 배경(파스텔 정원)에는 정해진 구멍이 없으므로
   화면 정중앙에 사진 상자를 놓는다(50%/50% + translate(-50%,-50%)).
   🔴 상자 비율은 **촬영 중 보이는 창과 같아야 한다** — 크롭이 달라지면 "이렇게 찍혔어요" 가
      방금 본 장면과 어긋나 보인다. 2026-08-07 액자 교체로 창 비율이 1.539 → **1.669** 로
      바뀌었으므로(구멍 1573x942) 이 상자도 함께 맞춘다. 폭은 그대로 두고 높이만 줄였다. */
.fp-shoot-done .fp-shoot-stage {
  left: 50%;
  top: 50%;
  width: 53.854%; /* 1034/1920 */
  height: 51.633%; /* 619.6/1200 — 1034/1.669 */
  transform: translate(-50%, -50%);
  background: transparent;
  border-radius: calc(24 * var(--shoot-u));
  box-shadow: 0 calc(10 * var(--shoot-u)) calc(36 * var(--shoot-u)) rgba(76, 60, 40, 0.28);
}

/* 캡처 후에는 라이브 영상 대신 캡처 프레임(canvas)만 보여준다.
   ⚠️ canvas 엘리먼트는 촬영/미리보기 상태에서 **같은 노드로 유지**해야 한다.
      상태에 따라 트리를 갈아끼우면 언마운트로 그려둔 비트맵이 사라진다. */
.fp-shoot-done .fp-shoot-video {
  visibility: hidden;
}

/* 🔴 마무리 화면 규칙(\`.fp-shoot-final\`/\`.fp-final-girl\`)은 2026-08-14 에 제거했다.
   그 화면이 공용 \`MissionDoneScreen\`(OxQuizFlow.css)으로 옮겨가 이 파일의 규칙은
   아무 요소에도 붙지 않는 죽은 코드가 됐다. 자산 \`final_girl.webp\` 도 함께 미사용. */

`, "",{"version":3,"sources":["webpack://./src/components/quest/FunnyPhotoRunner.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;;;;;;;;;;2DAW2D;;AAE3D;4EAC4E;AAC5E;EACE,qBAAqB;EACrB,+DAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,+BAA+B;EACjD,kDAAkD,EAAE,cAAc;;EAElE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gFAAgF;;EAEhF;;;+CAG6C;EAC7C,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE,yDAAkE;AACpE;;AAEA;EACE;IACE,yDAAmE;EACrE;AACF;;AAEA;;;;;;;;;;;;8CAY8C;AAC9C;EACE,kBAAkB;EAClB;kDACgD;EAChD,aAAa,IAAI,gBAAgB;EACjC,YAAY,KAAK,gBAAgB;EACjC,eAAe,GAAG,mBAAmB;EACrC,cAAc,IAAI,mBAAmB;EACrC,gBAAgB;EAChB,mBAAmB,EAAE,4BAA4B;EACjD,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;;;;wCAOwC;AACxC;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,gFAAwF;EACxF,oBAAoB;EACpB,UAAU;AACZ;;AAEA;AACA;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,qFAAmG;EACnG,oBAAoB;EACpB,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sEAAsE;EACtE,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gFAA0F;AAC5F;;AAEA;yDACyD;AACzD;EACE,kBAAkB;EAClB;;;;;;qDAMmD;EACnD,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;EAClC,YAAY;EACZ,yDAAmE;EACnE,4BAA4B;EAC5B;;;;;;kDAMgD;EAChD,yEAAyE;EACzE,sCAAsC;AACxC;;AAEA;+CAC+C;AAC/C;EACE,sEAAsE;AACxE;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;;;;4DAK4D;AAC5D;EACE,SAAS;EACT,QAAQ;EACR,cAAc,EAAE,cAAc;EAC9B,eAAe,EAAE,4BAA4B;EAC7C,gCAAgC;EAChC,uBAAuB;EACvB,wCAAwC;EACxC,wFAAwF;AAC1F;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;;4DAE4D","sourcesContent":["/**\n * 웃긴 표정 러너 스타일 — 가로 태블릿. 전면 카메라 + 카운트다운/캡처 연출.\n * 모든 클래스는 .fp-runner 하위로 스코프(다른 화면과 충돌 방지).\n */\n\n.fp-runner {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  padding: 8px;\n  /* 가이드 문구 + 카메라 뷰를 살짝 위로 (세로 중앙정렬 기준 상향) */\n  margin-top: -80px;\n}\n\n.fp-runner .fp-btn {\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n/* ── 카메라 오류 ── */\n.fp-runner-error {\n  text-align: center;\n  gap: 16px;\n}\n\n.fp-runner .fp-error-icon {\n  font-size: 56px;\n}\n\n.fp-runner .fp-error-text {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #b91c1c;\n}\n\n.fp-runner .fp-btn-cancel {\n  background: #059669;\n  color: #fff;\n  padding: 12px 28px;\n  font-size: 18px;\n  border-radius: 12px;\n}\n\n@keyframes fp-pop {\n  0% {\n    transform: scale(0.85);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* ══ 촬영 화면(카운트다운) — Figma 3272:46598 ══ (2026-08-07 교체, 옛 출처 2300:106265)\n   원본 프레임 1920x1200.\n\n   레이어 순서: 카메라(z:1, 화면 전체) → 나무 액자(z:2, **가운데 투명**) →\n                프레리독(z:3) → 카운트다운 말풍선(z:4).\n\n   🔴 좌표 규칙이 바뀌었다. 옛 화면은 불투명 배경을 `100% 100%` 로 늘려 채우고 그 안의 빈\n      사각형에 카메라를 앉혔기 때문에, 오버레이도 같은 비율로 늘어나도록 **% 좌표**를 써야\n      했다. 새 액자는 가운데가 투명해 카메라를 통째로 깔고 덮는 구조라, 액자를 뺀 나머지\n      요소(말풍선·프레리독)는 그림에 박힌 구멍이 아니라 **화면 위 독립 배치**다.\n      → 디자인 수치를 그대로 쓰는 `--shoot-u`(Figma 1px) 기준으로 통일한다.\n      단 액자 자체는 여전히 `100% 100%` 로 늘려 채운다(3:2 태블릿에서 잘림 방지). */\n\n/* 이 컴포넌트만 단독으로 쓰여도 글꼴이 깨지지 않도록 자체 선언\n   (OxQuizRunner.css·QuestTagPage.css 도 같은 파일을 선언 — src 가 같아 브라우저가 dedupe) */\n@font-face {\n  font-family: 'Katuri';\n  src: url('../../assets/fonts/andong-katuri/Katuri.otf') format('opentype');\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n.fp-shoot {\n  --shoot-scale: 1; /* 글자 크기 조절 손잡이. 1 = Figma 원본 */\n  --shoot-u: calc(100vw / 1920 * var(--shoot-scale)); /* Figma 1px */\n\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  font-family: 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  /* 🔴 촬영 중에는 배경 그림이 없다 (2026-08-07, Figma 3272:46598).\n     액자가 **가운데 투명 이미지**라 카메라 위에 덮는 오버레이(.fp-shoot-frame)로 올라간다.\n     카메라가 붙기 전 잠깐 흰 화면이 보이지 않게 어두운 초록만 깔아 둔다.\n     캡처 후에는 아래 .fp-shoot-done 이 파스텔 배경으로 바꾼다. */\n  background-color: #0b2e22;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n/* 캡처 후 미리보기(\"이렇게 찍혔어요\") — Figma 2300:106134 (파스텔 정원 배경) */\n.fp-shoot-done {\n  background-image: url('../../assets/quest/photo_bg_1280x800.webp');\n}\n\n@media (min-width: 1600px) {\n  .fp-shoot-done {\n    background-image: url('../../assets/quest/photo_bg_1920x1200.webp');\n  }\n}\n\n/* ── 카메라 뷰: 액자 구멍에 맞춘다 ──\n   🔴 `inset: 0`(화면 전체)로 두면 안 된다 (2026-08-07 수정, 사용자 보고 \"테두리 바깥\n      흰색에서도 나타난다\"). 액자는 가운데만 투명한 게 아니라 **바깥쪽에도 투명 여백**이 있다\n      (에셋 알파 실측: 상 57 / 하 32 / 좌 64 / 우 53px). 구멍 밖 투명 영역이 화면의 10.92%\n      라서, 전체에 깔린 영상이 나무 테두리 바깥으로 그대로 샜다.\n\n   좌표는 **컨테이너 대비 %** 다. 액자를 `100% 100%` 로 늘려 채우므로(태블릿 3:2, 원본 16:10)\n   창도 같은 비율로 늘어나야 구멍과 어긋나지 않는다. vw 기준(--shoot-u)으로 두면 종횡비가\n   바뀔 때 창이 구멍에서 밀린다.\n\n   구멍(에셋 알파 실측, 1920x1200 기준): x 179..1751 / y 145..1088\n   여기에 **바깥으로 6px 여유**를 준다 — 넘친 부분은 나무 테두리(두께 100px 이상)에 가려\n   보이지 않는 반면, 모자라면 유기적인 구멍 가장자리에 배경색 틈이 비친다. */\n.fp-shoot .fp-shoot-stage {\n  position: absolute;\n  /* 🔴 액자 구멍 실측 x71..1851 / y71..1134 (2026-08-19 `fp_ready_bg.webp` 재사용).\n     사방 6 씩 물려 가장자리에 배경색 틈이 생기지 않게 한다(기존 기법 유지). */\n  left: 3.3854%;   /* (71-6)/1920 */\n  top: 5.4167%;    /* (71-6)/1200 */\n  width: 93.3854%;  /* (1781+12)/1920 */\n  height: 89.75%;   /* (1065+12)/1200 */\n  overflow: hidden;\n  background: #0b2e22; /* 카메라 준비 전 흰 화면 대신 어두운 초록 */\n  z-index: 1;\n}\n\n.fp-shoot .fp-shoot-video,\n.fp-shoot .fp-shoot-canvas {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: scaleX(-1); /* 셀카 거울 모드 — 사용자가 보는 대로 */\n}\n\n.fp-shoot .fp-shoot-canvas {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* 🔴 스트림 재생 전에는 카메라 영상을 가린다 (2026-08-19 사용자 보고).\n   `getUserMedia` 가 비동기라 렌더 직후~`srcObject` 부착 사이에 **빈 `<video>`** 가 남고,\n   Android WebView 가 그 구간에 네이티브 재생 오버레이를 그렸다.\n   전역 의사요소 억제(`index.css`)와 **짝**이다 — 기기에 따라 아이콘이 아니라 빈 판이\n   먼저 뜨기도 해서 두 겹으로 막는다.\n   ⚠️ `onPlaying` 까지만 가린다 — 카메라가 켜지는 순간 아이는 자기 얼굴을 그대로 본다.\n   ⚠️ 캡처 후에는 `.fp-shoot-done .fp-shoot-video { visibility: hidden }` 이 따로 숨긴다.\n   회귀 가드: src/videoPlayOverlay.test.js */\n.fp-shoot .fp-shoot-video {\n  opacity: 0;\n  transition: opacity 120ms linear;\n}\n\n.fp-shoot .fp-shoot-video-playing {\n  opacity: 1;\n}\n\n.fp-shoot .fp-shoot-canvas-show {\n  opacity: 1;\n}\n\n.fp-shoot .fp-shoot-flash {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(5, 150, 105, 0.6);\n  animation: fp-pop 0.25s ease-out;\n}\n\n/* ── 사용자가 제공한 1920x1200 투명 사진 프레임 ── */\n.fp-shoot .fp-shoot-frame {\n  position: absolute;\n  inset: 0;\n  background: url('../../assets/quest/funny_photo_frame.png') no-repeat center / 100% 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n\n@media (min-width: 1600px) {\n}\n\n/* ── 사용자가 제공한 좌하단 프레리독 ── */\n.fp-shoot .fp-shoot-photographer {\n  position: absolute;\n  left: calc(54 * var(--shoot-u));\n  bottom: calc(30 * var(--shoot-u));\n  width: calc(550 * var(--shoot-u));\n  height: calc(630 * var(--shoot-u));\n  background: url('../../assets/quest/funny_photo_prairie_dog.png') no-repeat center bottom / contain;\n  pointer-events: none;\n  z-index: 3;\n}\n\n/* ── 카운트다운 말풍선 (3304:44130) — (1416,30) 460x396 ── */\n.fp-shoot .fp-shoot-bubble {\n  position: absolute;\n  z-index: 4;\n}\n\n.fp-shoot .fp-shoot-bubble-right {\n  /* 🔴 2026-08-19 — 우상단(1416,30)에서 **우하단**으로 내려왔다 (Figma 3846:45744). */\n  left: calc(1399 * var(--shoot-u));\n  top: calc(693 * var(--shoot-u));\n  width: calc(430 * var(--shoot-u));\n  height: calc(441 * var(--shoot-u));\n}\n\n.fp-shoot .fp-shoot-bubble-img {\n  position: absolute;\n  inset: 0;\n  background: url('../../assets/quest/shoot_bubble_count.webp') no-repeat center / 100% 100%;\n}\n\n/* 숫자 (3304:44132) — 중심 x 1646(=960+686), top 96, GosanjaOTF 250px #189018.\n   말풍선 상자(left 1416)를 기준으로 하면 중심은 1646-1416 = 230 지점이다. */\n.fp-shoot .fp-shoot-count {\n  position: absolute;\n  /* 🔴 2026-08-19 — 숫자가 **텍스트에서 스프라이트 이미지로** 바뀌었다 (Figma 3846:45746).\n     5·4·3·2·1 이 각각 다른 색의 3D 그림이라 폰트로는 재현할 수 없다.\n     말풍선(1399,693) 기준 상대좌표 (101,68), 창 228x274.\n     🔴 좌표를 transform 으로 잡지 않는다 — 아래 `fp-count-pop` 이 transform: scale 을\n        애니메이션하므로 translate 가 통째로 무시된다(2026-08-07 실제 사고).\n     🔴 글자는 DOM 에 남기고 `font-size: 0` 으로 화면에서만 감춘다 — 지우면 `textContent` 로\n        카운트다운을 확인하는 기존 테스트가 전부 눈이 먼다(접근성 낭독도 유지된다). */\n  left: calc(101 * var(--shoot-u));\n  top: calc(68 * var(--shoot-u));\n  width: calc(228 * var(--shoot-u));\n  height: calc(274 * var(--shoot-u));\n  font-size: 0;\n  background-image: url('../../assets/quest/shoot_count_digits.webp');\n  background-repeat: no-repeat;\n  /* 🔴 2026-08-19 재작업 — 시트를 **창과 같은 폭의 균일 칸**으로 다시 만들었다.\n     사용자 보고: \"1은 왼쪽에 2가 살짝 보인다\". 원인은 원본 시트의 들쭉날쭉한 자간이었다 —\n     창(228=원본 440)을 숫자 중심에 맞추다 보니, 폭이 좁은 '1'(260)에서는 창이 왼쪽으로\n     더 뻗어 73 밖에 안 떨어진 '2' 를 약 17 물었다. 자간에 맞춰 오프셋을 손보는 대신\n     시트를 440x529 칸 5개(2200x529)로 재구성해 **한 칸 = 한 창**이 되게 했다.\n     → 이웃이 들어올 여지가 구조적으로 없고, 오프셋도 창 폭의 정수배로 떨어진다.\n     시트 2200x529 → 화면 1140x274.1 (= 228 x5, 274) */\n  background-size: calc(1140 * var(--shoot-u)) calc(274.1 * var(--shoot-u));\n  animation: fp-count-pop 0.32s ease-out;\n}\n\n/* 숫자별 스프라이트 칸 — 시트가 왼쪽부터 5·4·3·2·1 이고 칸 폭이 창과 같으므로\n   오프셋은 창 폭(228)의 정수배다. 세로는 칸 안에서 이미 맞춰 두어 0. */\n.fp-shoot .fp-shoot-count[data-count=\"5\"] {\n  background-position: calc(0 * var(--shoot-u)) calc(0 * var(--shoot-u));\n}\n\n.fp-shoot .fp-shoot-count[data-count=\"4\"] {\n  background-position: calc(-228 * var(--shoot-u)) calc(0 * var(--shoot-u));\n}\n\n.fp-shoot .fp-shoot-count[data-count=\"3\"] {\n  background-position: calc(-456 * var(--shoot-u)) calc(0 * var(--shoot-u));\n}\n\n.fp-shoot .fp-shoot-count[data-count=\"2\"] {\n  background-position: calc(-684 * var(--shoot-u)) calc(0 * var(--shoot-u));\n}\n\n.fp-shoot .fp-shoot-count[data-count=\"1\"] {\n  background-position: calc(-912 * var(--shoot-u)) calc(0 * var(--shoot-u));\n}\n\n@keyframes fp-count-pop {\n  0% {\n    transform: scale(1.35);\n    opacity: 0.35;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* ══ 캡처 후 미리보기 배치 ══\n   요구: \"사진이 화면 가운데 오도록\". 배경(파스텔 정원)에는 정해진 구멍이 없으므로\n   화면 정중앙에 사진 상자를 놓는다(50%/50% + translate(-50%,-50%)).\n   🔴 상자 비율은 **촬영 중 보이는 창과 같아야 한다** — 크롭이 달라지면 \"이렇게 찍혔어요\" 가\n      방금 본 장면과 어긋나 보인다. 2026-08-07 액자 교체로 창 비율이 1.539 → **1.669** 로\n      바뀌었으므로(구멍 1573x942) 이 상자도 함께 맞춘다. 폭은 그대로 두고 높이만 줄였다. */\n.fp-shoot-done .fp-shoot-stage {\n  left: 50%;\n  top: 50%;\n  width: 53.854%; /* 1034/1920 */\n  height: 51.633%; /* 619.6/1200 — 1034/1.669 */\n  transform: translate(-50%, -50%);\n  background: transparent;\n  border-radius: calc(24 * var(--shoot-u));\n  box-shadow: 0 calc(10 * var(--shoot-u)) calc(36 * var(--shoot-u)) rgba(76, 60, 40, 0.28);\n}\n\n/* 캡처 후에는 라이브 영상 대신 캡처 프레임(canvas)만 보여준다.\n   ⚠️ canvas 엘리먼트는 촬영/미리보기 상태에서 **같은 노드로 유지**해야 한다.\n      상태에 따라 트리를 갈아끼우면 언마운트로 그려둔 비트맵이 사라진다. */\n.fp-shoot-done .fp-shoot-video {\n  visibility: hidden;\n}\n\n/* 🔴 마무리 화면 규칙(`.fp-shoot-final`/`.fp-final-girl`)은 2026-08-14 에 제거했다.\n   그 화면이 공용 `MissionDoneScreen`(OxQuizFlow.css)으로 옮겨가 이 파일의 규칙은\n   아무 요소에도 붙지 않는 죽은 코드가 됐다. 자산 `final_girl.webp` 도 함께 미사용. */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
